import convertObjectToFormData from "../utils/convertObjectToFormData";
import config from '../config';

export async function fetchBranches(providerId, token, q) {

    const res = await fetch(`${config.API_URL}/branch?q=${q} `, {

        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
    });
    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function addBranch(providerId, branch, token) {
    let formData = convertObjectToFormData(branch);

    const res = await fetch(`${config.API_URL}/branch`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function updateBranch(providerId, branch, token) {
    const formData = convertObjectToFormData(branch);
    const res = await fetch(`${config.API_URL}/branch`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
        body: formData,
    })
    if (res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function toggleBranchVisibility(providerId, branchId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({ providerId,branchId })

    const res = await fetch(`${config.API_URL}/branch/toggle-visibility`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function deleteBranch(providerId, branch, token) {
    let formData = new FormData();
    formData.append("_id", branch._id)
    const res = await fetch(`${config.API_URL}/branch`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function validateBranch(providerId, branchId, isValidated, token){
    const formData = convertObjectToFormData({ providerId,branchId, isValidated })

    const res = await fetch(`${config.API_URL}/branch/validate-branch`, {
        method: 'put',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
        },
        body: formData
    });

    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}